import type { DtisLabel, DynamicFlatNode, EchartsConfig, LanguageCode, ThemeOptions } from 'commons';

export class Search {
  static readonly type = '[Settings] search]';
  constructor(public readonly payload: { value: string }) {}
}

export class ToggleDatasourceRefresh {
  static readonly type = '[Settings] toggle Autorefresh';
  constructor(public readonly datasource: DynamicFlatNode) {}
}

export class ToggleDebugMode {
  static readonly type = '[Settings] toggle Debugmode';
}

export class DataBrowserCollapseAction {
  static readonly type = '[Settings] toggle Collapse';
}

export class SetAdminMode {
  static readonly type = '[Settings] set Adminmode';
  constructor(public readonly isAdmin: boolean) {}
}

export class ToggleFilterPanel {
  static readonly type = '[Settings] toggle FilterPanel';
}

export class SaveTabPosition {
  static readonly type = '[Settings] Save Tab Position';
  constructor(public readonly position: number) {}
}
export class GetLabels {
  static readonly type = '[Settings] get Labels';
}
export class GetLabelsOfBusinessUnit {
  static readonly type = '[Settings] get Labels';
  constructor(public readonly bu_id: string) {}
}
export class AddLabel {
  static readonly type = '[Settings] add Label';
  constructor(
    public readonly label: Partial<DtisLabel>,
    public readonly bu_id: string
  ) {}
}
export class DeleteLabel {
  static readonly type = '[Settings] remove Label';
  constructor(
    public readonly labelId: string,
    public readonly bu_id: string
  ) {}
}

export class ToggleSidebar {
  static readonly type = '[Settings] toggle Sidebar';
}

export class SetLanguage {
  static readonly type = '[Settings] Set Language';
  constructor(public language: LanguageCode) {}
}

export class SetTheme {
  static readonly type = '[Settings] Set Theme';
  constructor(public theme: ThemeOptions) {}
}

export class ApplyLanguage {
  static readonly type = '[Settings] Apply Language';
  constructor(public language?: LanguageCode) {}
}

export class SetResolutionMultiplier {
  static readonly type = '[Settings] Set Resolution Multiplier';
  constructor(public resolutionMultiplier: number) {}
}

export class SetGridHeight {
  static readonly type = '[Settings] Set Grid Height';
  constructor(public gridHeight: number) {}
}

export class SetGridConfig {
  static readonly type = '[Settings] Set Grid Config';
  constructor(public config: Partial<EchartsConfig>) {}
}
